import React from 'react';
import { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import Avatar from 'src/app/molecules/Avatar/Avatar';
import { AttributionTextContainer } from './Attribution.styles';

export interface AttributionProps {
  avatarWrapper?: AssetWrapperProps;
  authorName: TypographyProps;
  authorTitle?: TypographyProps;
  textAlignSm?: 'left' | 'center';
}

const Attribution = ({
  avatarWrapper,
  authorName,
  authorTitle,
  textAlignSm = 'center',
}: AttributionProps): JSX.Element => {
  return (
    <Stack
      gap='spacing-xl'
      align={textAlignSm === 'left' ? 'flex-start' : 'center'}
      directionSm='column'
    >
      {avatarWrapper && <Avatar {...avatarWrapper} />}
      <AttributionTextContainer
        direction='column'
        gap='spacing-xs'
        className={`attribution-text-container sm-text-align-${textAlignSm || 'none'}`}
      >
        <Typography
          className='author-name'
          {...authorName}
        />
        {authorTitle && (
          <Typography
            className='author-title'
            color='text-tertiary'
            {...authorTitle}
          />
        )}
      </AttributionTextContainer>
    </Stack>
  );
};

export default Attribution;
